app.service("OrderReplacementService", ['$rootScope', function ($rootScope) {

    const modelConstructor = $rootScope.model_constructor;
    const siteHelper = $rootScope.site_helper;
    const requestService = $rootScope.service.request;

    const OrderReplacementModel = modelConstructor.extend(modelConstructor.BasicModel, {
        name: "Order Replacement",
        id: "order_replacement",
        has_a_completed_list_request: false,
        list_request_in_progress: false,
        fault_types: null,
        listRequestCallbacks: [],
        requestReplacementList: requestReplacementList,
        requireFaultTypes: requireFaultTypes
    });

    this.model = new OrderReplacementModel();
    const model = this.model;

    function requestReplacementList(callback) {
        if (callback) {
            model.listRequestCallbacks.push(callback);
        }
        if (model.list_request_in_progress) {
            return
        }
        model.list_request_in_progress = true;
        const endpoint = '/request/api.php/replacements';
        requestService.getRequest(endpoint, function (success, data, messages) {
            model.list_request_in_progress = false;
            let i;
            if (success) {
                model.has_a_completed_list_request = true;
                model.choice_order.length = 0;
                for (i = 0; i < data.length; i++) {
                    const order = data[i];
                    order.status_name = siteHelper.uppercaseFirstWords(((order._status ?? "").split("_").join(" ")).toLowerCase());
                    const orderID = order._id;
                    model.choice_order.push(orderID)
                    model.choices[orderID] = order;
                }
            }
            const choiceList = model.choiceList();
            for (i = 0; i < model.listRequestCallbacks.length; i++) {
                model.listRequestCallbacks[i](success, choiceList, messages);
            }
            model.listRequestCallbacks.length = 0;
        })
    }

    this.requestReplacementEntry = function (replacementID, callback) {
        const endpoint = '/request/api.php/replacements/' + replacementID;
        requestService.getRequest(endpoint, function (success, replacement) {
            if(success){
                replacement.status_name = siteHelper.uppercaseFirstWords(((replacement._status ?? "").split("_").join(" ")).toLowerCase());
            }
            if(callback){
                callback(success, replacement);
            }
        })
    }


    this.addMessage = function (replacementID, message, callback) {

        const object = {
            type: "text",
            message: message
        }

        const endpoint = '/request/api.php/replacements/' + replacementID + '/messages';

        requestService.postJsonRequest(endpoint, object, function (success, response, errors) {
            if (callback) {
                callback(success, response, errors);
            }
        });
    }


    this.addImage = function (replacementID, imageURL, callback) {

        const object = {
            type: "image",
            message: imageURL
        }

        const endpoint = '/request/api.php/replacements/' + replacementID + '/messages';

        requestService.postJsonRequest(endpoint, object, function (success, response, errors) {
            if (callback) {
                callback(success, response, errors);
            }
        });
    }

    function requireFaultTypes(callback) {
        const model = this.root;

        if (model.fault_types) {
            if (callback) {
                callback(true, model.fault_types.choice_list);
            }
            return;
        }

        const endpoint = '/request/api.php/replacements/fault_types';
        requestService.getRequest(endpoint, function (success, data, messages) {

            let i;
            if (success) {
                const choices = {};
                const choiceList = [];
                for (let key in data) {
                    const faultType = data[key];
                    choices[faultType.id] = faultType;
                    choiceList.push(faultType);
                }

                choiceList.sort(function (a, b) {
                    if (a.id < b.id) {
                        return -1;
                    }
                    if (a.id > b.id) {
                        return 1;
                    }
                    return 0;
                })
                model.fault_types = {
                    choices: choices,
                    choice_list: choiceList
                }
            }
            if (callback) {
                callback(success, model.fault_types.choice_list, messages);
            }
        })
    }

    this.submitReplacementOrder = function (replacementOrder, callback) {

        const endpoint = '/request/api.php/replacements/submit';

        requestService.postJsonRequest(endpoint, replacementOrder, function (success, replacementOrder, errors) {

            if (replacementOrder) {
                if (replacementOrder._errors) {
                    success = false;
                    if (replacementOrder.lines.length > 0 && replacementOrder.lines[0]._errors) {
                        siteHelper.addErrorMessage(replacementOrder.lines[0]._errors, errors);
                    } else {
                        siteHelper.addErrorMessage(replacementOrder._errors, errors);
                    }
                }
            }
            if (callback) {
                callback(success, replacementOrder, errors);
            }
        })
    }

    this.respondPayment = function (replacementID, isAccept, callback) {

        const endpoint = '/request/api.php/replacements/' + replacementID +'/' + (isAccept ? 'payment_accept' : 'payment_decline');

        requestService.postJsonRequest(endpoint, null, function (success, response, errors) {
            if (callback) {
                callback(success, response, errors);
            }
        })
    }

}]);